// extracted by mini-css-extract-plugin
export var dataCell = "_o6-2";
export var dataRow = "_o6-0";
export var headerRow = "_o6-1";